import { useTheme } from "@mui/system";
import { Tooltip } from "@mui/material";

import { useTranslate } from "src/locales";
import { CompanyProfileType } from "src/services/connections/connections.types";

import Iconify from "src/components/iconify";

type LabelProps = {
    type?: CompanyProfileType;
};

export function CompanyProfileTypeIcon({ type }: LabelProps) {

    const { t } = useTranslate();

    const theme = useTheme();

    const getIcon = () => {
        switch (type) {
            case CompanyProfileType.UNLINKED:
                return "material-symbols:verified-off-outline-rounded";
            case CompanyProfileType.LINKED:
                return "material-symbols:verified-outline-rounded";
            case CompanyProfileType.PRIMARY:
                return "material-symbols:verified";
            default:
                return "akar-icons:unverified-fill";
        }
    }

    const getColor = () => {
        switch (type) {
            case CompanyProfileType.UNLINKED:
                return "gray";
            case CompanyProfileType.LINKED:
                return theme.palette.primary.main;
            case CompanyProfileType.PRIMARY:
                return theme.palette.primary.main;
            default:
                return "gray";
        }
    }

    return (
        <Tooltip title={t(`connections.profile_status.${type}_tooltip`)}>
            <Iconify icon={getIcon()} width={20} height={20} color={getColor()} />
        </Tooltip>
    )
}
